import { GraphicsWidget } from "./graphics.js";

export class InlineGraphicsWidget extends GraphicsWidget {
    toDOM(view) {
        this.height = 28;
        const element = document.createElement("span");
        element.classList.add("ol-cm-graphics-inline");
        this.renderGraphic(element, view);

        return element;
    }

    ignoreEvent(event) {
        return event.type !== "mousedown" && event.type !== "mouseup";
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
